import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminWithdrawals.css';

const AdminWithdrawals = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/admin/withdrawals');
      setLogs(res.data);
      setError(null);
    } catch (err) {
      setError('Failed to fetch logs');
    } finally {
      setLoading(false);
    }
  };

  const retry = async (id) => {
    if (!window.confirm('Retry this failed withdrawal?')) return;
    try {
      const res = await axios.post(`/api/admin/withdrawals/retry/${id}`);
      alert(res.data.message);
      fetchLogs();
    } catch (err) {
      alert('Retry failed');
    }
  };

  const exportCSV = () => {
    const headers = ['Email', 'Amount USD', 'Amount Local', 'Method', 'Status', 'Date'];
    const rows = logs.map(l => [
      l.email,
      l.amountUsd,
      l.amountLocal,
      l.method,
      l.status,
      new Date(l.timestamp).toLocaleString()
    ]);

    let csv = headers.join(',') + '\n';
    rows.forEach(row => csv += row.join(',') + '\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'withdrawals.csv';
    a.click();
  };

  const totalPaid = logs
    .filter(l => l.status === 'success')
    .reduce((sum, l) => sum + l.amountUsd, 0);

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="admin-withdrawals">
      <h2>Author Withdrawal Logs</h2>
      <button className="export-btn" onClick={exportCSV}>Export CSV</button>
      <p>Total Paid to Authors: ${totalPaid.toFixed(2)}</p>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <div className="table-wrapper">
          <table className="withdrawal-table">
            <thead>
              <tr>
                <th>Email</th><th>USD</th><th>Local</th><th>Method</th><th>Status</th><th>Date</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log._id} className={log.status === 'failed' ? 'failed-row' : ''}>
                  <td>{log.email}</td>
                  <td>${log.amountUsd.toFixed(2)}</td>
                  <td>{log.amountLocal}</td>
                  <td>{log.method}</td>
                  <td>
                    <span className={`status-badge ${log.status}`}>
                      {log.status.toUpperCase()}
                    </span>
                  </td>
                  <td>{new Date(log.timestamp).toLocaleString()}</td>
                  <td>
                    {log.status === 'failed' && (
                      <>
                        <button className="retry-btn" onClick={() => retry(log._id)}>?? Retry</button>
                        {log.note && <small className="note">Note: {log.note}</small>}
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminWithdrawals;